const headers = {
  name: "Delivery Note",
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search",
      value: "",
    },
    {
      type: "filter",
      name: "customer",
      allowClear: true,
      showSearch: true,
      filterOption: false,
      placeholder: "Customer",
      api: "get-all-customers",
      value: null,
      options: null,
    },
    {
      type: "filter",
      name: "sales_order",
      allowClear: true,
      showSearch: true,
      filterOption: false,
      placeholder: "Sales Order",
      api: "get-all-sales-order",
      value: null,
      options: null,
    },
    {
      type: "range",
      name: "date",
      value: {
        start: "",
        end: "",
      },
    },
    {
      type: "range",
      name: "due_date",
      placeholder: ["Due Start Date", "Due End Date"],
      value: {
        start: "",
        end: "",
      },
    },
    {
      type: "add",
      path: "/app/sales/delivery-note/add",
    },
  ],
  navigate: {
    tabs: [
      {
        name: "SO",
        path: "/app/sales/sales-order",
      },
      {
        name: "DO",
        path: "",
      },
      {
        name: "Invoices",
        path: "/app/sales",
      },
      {
        name: "Returns",
        path: "/app/sales/returns",
      },
      {
        name: "Quotes",
        path: "/app/sales/quotes",
      },
      {
        name: "Bookings",
        path: "/app/sales/bookings",
      },
      {
        name: "Credit Notes",
        path: "/app/sales/credit-notes",
      },
    ],
    total: [
      { value: 0, label: "Total" },
      { value: 0, label: "Active" },
      { value: 0, label: "Inactive" },
    ],
  },
};

export default headers;